import { FeApi } from '../..';
import type { SitePreview } from '../../domain/entities/site';

export function sitePreviewMapper(data: FeApi.Site): SitePreview {
  return {
    id: data.accure_id,
    fullFrontendId: data.full_frontend_id,
    name: data.name,
  };
}
